import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPageData, useData } from '../../../app/helper/functions';
import images from '../../../app/utlis/image';

interface SubMenuProps {
  items: any;
  isOpen: boolean;
  handleNavigation: (path: string) => void;
}

// SubMenu component for second level
const SubMenu: React.FC<SubMenuProps> = ({ isOpen, handleNavigation, items }) => {
  if (!isOpen) return null;
  return (
    <div className="pl-4 mt-1 border-l-2 border-gray-700">
      {items.value.map((item: any, idx: number) => {
        return (
          <div key={idx}>
            <div
              className="py-2 text-gray-200 hover:text-yellow-400 cursor-pointer"
              onClick={() => item.navigate && handleNavigation(item.navigate)}
            >
              {item.value}
            </div>
          </div>
        )
      })}
    </div>
  );
};


interface OpenSubMenusState {
  [key: number]: boolean;
}

const MobileHeader: React.FC = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubMenus, setOpenSubMenus] = useState<OpenSubMenusState>({});
  const [activeService, setActiveService] = useState<any>(null);

  const menuRef = useRef<HTMLDivElement>(null);
  const { data } = useData();
  const homePageData = getPageData(data, 'HomePageData');
  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setActiveService(homePageData.headerServicesList[0])
  }, []);

  // Handle navigation
  const handleNavigation = (path: string) => {
    navigate(path);
    setMenuOpen(false);
  };

  // Toggle submenu visibility
  const toggleSubMenu = (index: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenSubMenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="relative bg-theme shadow-lg" ref={menuRef}>
      <div className="flex items-center justify-between p-4">
        <img
          src={images.LOGO}
          className="w-32 bg-white p-1 rounded-lg"
          alt="Logo"
          onClick={() => navigate('/')}
        />
        <button
          className="text-white text-2xl focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? (
            <span className="text-2xl">✕</span>
          ) : (
            <span className="text-2xl">☰</span>
          )}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`absolute top-full left-0 right-0 bg-theme shadow-xl z-20 transition-all duration-300 ${menuOpen ? 'max-h-screen overflow-y-auto' : 'max-h-0 overflow-hidden'
          }`}
      >
        <div className="p-4">
          <div className='cursor-pointer mb-2 font-medium py-2 text-white hover:text-yellow-400' onClick={() => { setMenuOpen(false); navigate('/') }}>Home</div>
          {homePageData.headerServicesList.map((item: any, index: number) => {
            return (
              <div key={index} className="mb-2">
                <div>
                  <div
                    className="flex items-center justify-between py-2 text-white cursor-pointer hover:text-yellow-400"
                    onClick={(e) => toggleSubMenu(index, e)}
                  >
                    <span className="font-medium">{item.title}</span>
                    <span
                      className={`transition-transform duration-200 ${openSubMenus[index] ? 'transform rotate-180' : ''} text-sm`}
                    >
                      ▼
                    </span>
                  </div>
                  <SubMenu
                    items={item}
                    isOpen={openSubMenus[index]}
                    handleNavigation={handleNavigation}
                  />
                </div>
              </div>
            )
          })}
          <div className='cursor-pointer mb-2 font-medium py-2 text-white ' onClick={() => { setMenuOpen(false); navigate('/aboutus') }}>About us</div>
          <div className='cursor-pointer mb-2 font-medium py-2 text-white ' onClick={() => { setMenuOpen(false); navigate('/career') }}>Career</div>
          <div className='cursor-pointer mb-2 font-medium py-2 text-white ' onClick={() => { setMenuOpen(false); navigate('/blog') }}>Blog</div>
          <div className='cursor-pointer mb-2 font-medium py-2 text-white ' onClick={() => { setMenuOpen(false); navigate('/contactus') }}>Get in Touch</div>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader; 